module.exports = __webpack_public_path__ + "static/img/35.79786b7e.png";